<template>
  <div class="equipWarning">
    <div class="warningList">
      <div class=" w-100 text-center" style="color:#909399;font-size: 22px;line-height:230px"
          v-if="eventsList.length === 0">
          {{ $t('base.no-data') }}
        </div>
      <div
        v-for="(warning, index) in eventsList"
        :key="index"
        class="list-cont mt-2"
      >
        <div class="warning-icon">
          <span
            class="type-icon"
            :style="{ backgroundImage: `url(${typeList[warning.level]})` }"
          ></span>
        </div>
        <div class="warning-main">
          <div class="main-head">
            <div class="warning-type">
              {{ textList[warning.level] }}
            </div>
            <div class="warning-time">
              {{ moment(warning.createdAt).format('YYYY-MM-DD hh:mm:ss') }}
            </div>
          </div>
          <div class="warning-cont">
            <!-- {{ warning.description || '-' }} -->
            {{
                equip_data.name +
                " " +
                handleKeyName(warning.measure_key)
              }}
              {{this.$t('page.event-management.enter')}}{{ textList[warning.level] }}{{this.$t('page.service-request.status.text')}}
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-end" v-if="eventsList.length">
      <div @click="$router.push('/iot/event-management?root_sn='+equip_data.root_sn)" style="cursor: pointer;color: #0096E3;">
        {{ $t("overview_static.common.details") }} >>
      </div>
    </div>
    <!-- <div v-if="false" class="warning-detail">
      <span class="detail cursor-pointer" @click="toDetails">{{
        $t("View Details")
      }}</span>
      <span class="d-icon cursor-pointer"></span>
    </div> -->
  </div>
</template>

<script>
import {  getEventsList } from "@/service";
import moment from "moment";
import qs from "qs";
export default {
  props: ["equip_data"],
  data() {
    return {
      measure_list:[],
      eventsList:[]
    };
  },
  computed: {
    typeList() {
      return {
        "NORMAL": require("@/assets/vsd420/remind.svg"),
        "ERROR": require("@/assets/vsd420/error.svg"),
        'WARNING': require("@/assets/vsd420/warning.svg"),
        "UNKNOWN": require("@/assets/images/healthy-state/faulty_.svg"),
      };
    },
    textList(){
      return {
        "NORMAL": this.$t('page.event-management.reminder'),
        "ERROR": this.$t('page.event-management.error'),
        'WARNING': this.$t('page.event-management.warning'),
        "UNKNOWN": this.$t('page.event-management.unknown'),
      };
    },
    // equipWarning() {
    //   if(this.$route.query.index==1){
    //     return [
    //       {
    //         name: this.$t("Error"),
    //         key: "error",
    //         time: "2023-09-04  18:25:11",
    //         text: "工作液温度过高，工作液温度33.5℃。",
    //         eName:"液环真空泵 AT 700"

    //       },
    //       {
    //         name: this.$t("Warning"),
    //         key: "warning",
    //         time: "2023-09-05  19:15:49",
    //         text: "电机电流有变化，不在允许范围内",
    //         eName:"液环真空泵 AT 700"

    //       },
    //       {
    //         name: this.$t("Warning"),
    //         key: "warning",
    //         time: "2023-09-05  20:25:49",
    //         text: "电机超功率",
    //         eName:"液环真空泵 AT 700"

    //       },
    //       {
    //         name: this.$t("Error"),
    //         key: "error",
    //         time: "2023-09-06  11:25:30",
    //         text: "轴承温度高",
    //         eName:"液环真空泵 AT 700"

    //       },
    //       {
    //         name: this.$t("Warning"),
    //         key: "warning",
    //         time: "2023-09-08  22:22:49",
    //         text: "振动温度高",
    //         eName:"液环真空泵 AT 700"
    //       },

    //     ];
    //   }else if(this.$route.query.index==2){
    //     return [
    //       {
    //         name: this.$t("Hint"),
    //         key: "remind",
    //         time: "2023-09-04  03:21:48",
    //         text: "干泵电机电流波动大。",
    //         eName:"干泵 VSD 800"
    //       },
    //       {
    //         name: this.$t("Error"),
    //         key: "error",
    //         time: "2023-09-04 13:24:47",
    //         text: "工作液温度过高，工作液温度33.5℃。",
    //         eName:"液环真空泵 AT 700"

    //       },
    //       {
    //         name: this.$t("Warning"),
    //         key: "warning",
    //         time: "2023-09-06  18:25:49",
    //         text: "冷却水温度过高，冷却水温度32.8℃。",
    //         eName:"干泵 VSD 800"

    //       },
    //       {
    //         name: this.$t("Error"),
    //         key: "error",
    //         time: "2023-09-07  22:25:49",
    //         text: "轴承震动异常，定位轴承震动4.0mm/s，横向震动6mm/s",
    //         eName:"风机 HRM 250-90"

    //       },

    //     ];
    //   }else{
    //     return [
    //       {
    //         name: this.$t("Warning"),
    //         key: "warning",
    //         time: "2023-09-05  18:23:49",
    //         text: "风气排气压力过高，排气压力750mabrG。",
    //         eName:"风机"

    //       },
    //       {
    //         name: this.$t("Error"),
    //         key: "error",
    //         time: "2023-09-05  23:25:19",
    //         text: "风机压差过高，压差80mba。",
    //         eName:"风机"

    //       },

    //     ];
    //   }

    // }
  },
  watch:{},
  mounted() {
   /* 测点列表 */ 
   if(this.equip_data&&this.equip_data.attributes&&this.equip_data.attributes.measurements){
        this.measure_list = this.equip_data.attributes.measurements
    }

    this.getEventsLists()
  },
  methods: {
    moment,
    /* 获取设备事件 */ 
    getEventsLists() {
      let params = {
        page: 1,
        page_size: 5,
        limit:5,
        shadowId: []
      }
      params['shadowId'].push(this.$route.query.equip_id)
      // this.instanceList.map(item => {
      //   params['shadowId'].push(item.id)
      // })
      params = qs.stringify(params, { arrayFormat: "repeat" })
      getEventsList(params).then(res => {
        if (res.payload && res.payload.data) {
          let list = res.payload.data
          list.length&&list.forEach(item => {
            let measure_key = ''
            if(item.forDeviceList&&item.forDeviceList.length&&item.forDeviceList[0]){
              measure_key = item.forDeviceList[0].telemetries[0]
            }
            item.measure_key = measure_key

          })
          this.eventsList = list

        }
      })
    },
    /* 根据测点key获取测点名称*/ 
    handleKeyName(key){
      let str = ''
      if(key){
        let info = this.measure_list.find(item=>item.key == key)

        if(info){
          str = info.name
        }
      }
      return str
    },
    toDetails() {
      var routeData = this.$router.resolve({
        path: "/EventAlarm",
        query: { id: 1 }
      });
      window.open(routeData.href, "_blank");
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipWarning {
  height: 100%;
  display: flex;
  flex-flow: column;
  color:#ffffff;
  .warningList {
    flex: 1;
    overflow: auto;
    // display: flex;
    // flex-flow: column;
    .list-cont {
      display: flex;
      flex: 1;
      margin: 20px 0;
      font-size: 15px;
    }
    .warning-icon {
      .type-icon {
        display: inline-block;
        margin-top: 3px;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .warning-main {
      flex: 1;
      .main-head {
        display: flex;
        align-items: center;
        .warning-type {
          flex: 1;
        }
        .warning-time {
          flex: 2;
          text-align: right;
          padding-right: 5px;
        }
      }
      .warning-cont {
        margin-top: 5px;
      }
    }
  }
  .warning-detail {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 8px 0;
    color: #00e7ff;
    font-size: 12px;

    .d-icon {
      width: 20px;
      height: 20px;
      background: url("../../../../../assets/arrow.svg") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
